// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__BEDid"};